import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { uploadImageApi } from "../../setting/uploadImage/uploadImageAction";
import { GetInsuranceServiceData, AddInsuranceGatePassApi, GetInsuranceServiceWithIdApi } from "./insuranceServiceAction";
import { useTranslation } from "react-i18next";
import { setHeading } from "../../../accounts/account.actions";
import _ from "lodash";
import Spinner from "react-bootstrap/Spinner";
import Select from "react-select";
import Swal from "sweetalert";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import ImageUploader from "react-images-upload";
import '../../../../../il8n';


const AddGatePass = (props) => {
    const { t, i18n } = useTranslation();
    const [claim, setClaim] = useState();
    const [survayDate, setSurvayDate] = useState();
    const [accidentDate, setAccidentDate] = useState();
    const [approvelDate, setApprovelDate] = useState();
    const [customerName, setCustomerName] = useState("");
    const [remarks, setRemarks] = useState()
    const [instructor, setInstructor] = useState();
    const [insuranceServiceId, setinsuranceServiceId] = useState();
    const [mainServiceName, setMainServiceName] = useState();
    const [visibleAlert, setAlertVisible] = useState(false);
    const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);


    const handleVisible = (msg) => {
        setAlertVisible(true);
        setTimeout(() => {
            setAlertVisible(false);
        }, 9000);
        Swal({
            title: "Success",
            text: msg,
            icon: "success",
            button: "Ok",
        });
    };
    const handleDangerVisible = (err) => {
        setDangerVisibleAlert(true);
        setTimeout(() => {
            setDangerVisibleAlert(false);
        }, 9000);
        Swal({
            title: "Error",
            text: err,
            icon: "error",
            button: "Ok",
        });
    };
    function SaveGatePass() {
        props.AddInsuranceGatePassApi({
            insuranceServiceId: insuranceServiceId,
            claim: claim,
            survayDate: survayDate,
            accidentDate: accidentDate,
            approvelDate: approvelDate,
            customerName: _.isEmpty(props.insuranceServiceDataListWithId[0]) ? "" : props.insuranceServiceDataListWithId[0].customerName,
            issuedBy: instructor,
            remarks: remarks,
            attachment: props.UploadImageURL,
        },
            handleVisible,
            handleDangerVisible,
        );
        setClaim("")
        setSurvayDate("")
        setAccidentDate("")
        setApprovelDate("")
        setInstructor("")
        setinsuranceServiceId("")
        setCustomerName("")
        setRemarks("")
    }

    const onDrop = (pictureFiles) => {
        props.uploadImageApi({
            image: pictureFiles[pictureFiles.length - 1],
        });
    };

    const handleChangeMainService = (selectedOption) => {
        setinsuranceServiceId(selectedOption.value);
        setMainServiceName(selectedOption.label);
        props.GetInsuranceServiceWithIdApi(selectedOption.value)
    };
    const getMainServiceList = !_.isEmpty(props.insuranceServiceDataList) && props.insuranceServiceDataList.map((x) => {
        let data = { value: x._id, label: `${x.seqNumber} / ${x.vehicleNumber} / ${x.vehicleMade} / ${x.customerName}` };
        return data;
    });

    useEffect(() => {
        props.setHeading("Gate Pass");
        props.GetInsuranceServiceData()
    }, []);

    return (<>
        {props.isAddingInsuranceGatePass || props.isFetchingInsuranceService ? (
            <div className="loader-div">
                <Spinner
                    variant="primary"
                    animation="border"
                    size="xl"
                    role="status"
                    aria-hidden="true"
                />
            </div>
        ) : (
            <Container fluid>
                <div className="main">
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>{t('SelectService')} *</b> </Form.Label>
                                <Select
                                    isDisabled={_.isEmpty(props.insuranceServiceDataList)}
                                    placeholder="Select Service"
                                    onChange={handleChangeMainService}
                                    options={getMainServiceList}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>{t('ClaimNumber')} *</b></Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Claim Number"
                                    onChange={(e) => setClaim(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>{t('SurvayDate')} *</b> </Form.Label>
                                <Form.Control
                                    type="date"
                                    placeholder="Survay Date"
                                    onChange={(e) => setSurvayDate(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>{t('AccidentDate')}</b></Form.Label>
                                <Form.Control
                                    type="date"
                                    placeholder="Accident Date"
                                    onChange={(e) => setAccidentDate(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>{t('ApprovelDate')} *</b></Form.Label>
                                <Form.Control
                                    type="date"
                                    placeholder="Approvel Date"
                                    onChange={(e) => setApprovelDate(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>{t('CustomerName')} </b> </Form.Label>
                                <Form.Control
                                    type="text"
                                    disabled={true}
                                    placeholder="Customer Name"
                                    value={_.isEmpty(props.insuranceServiceDataListWithId[0]) ? "" : props.insuranceServiceDataListWithId[0].customerName}
                                    onChange={(e) => setCustomerName(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>{t('Surveyor')} *</b></Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Surveyor"
                                    onChange={(e) => setInstructor(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>{t('Remarks')} </b></Form.Label>
                                <Form.Control
                                    type="text"
                                    as='textarea'
                                    rows={3}
                                    placeholder="Remarks / Description"
                                    onChange={(e) => setRemarks(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col xl="12" lg="12" md="12" sm="12" xs="12">
                            <Form.Group className="mb-3">
                                <Form.Label><b style={{ fontSize: "large" }}> {t('UploadImages')} </b></Form.Label>
                                <ImageUploader
                                    withIcon={false}
                                    buttonText="Upload Images"
                                    onChange={onDrop}
                                    imgExtension={[".jpg", ".jpeg", ".png"]}
                                    maxFileSize={999999999999999999999}
                                    singleImage={false}
                                    withPreview={true}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <div style={{ marginTop: '20px', textAlign: 'center' }}>
                        {_.isEmpty(mainServiceName) || _.isEmpty(claim) || _.isEmpty(survayDate) || _.isEmpty(approvelDate) || _.isEmpty(instructor) ? (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
                        ) : (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={SaveGatePass}> SAVE </Button>
                        )}
                    </div>

                </div>
            </Container>
        )}
    </>)

}

const mapDispatchToProps = (dispatch) => {
    return {
        AddInsuranceGatePassApi: (data, handleVisible, handleDangerVisible) => dispatch(AddInsuranceGatePassApi(data, handleVisible, handleDangerVisible)),
        GetInsuranceServiceData: () => dispatch(GetInsuranceServiceData()),
        uploadImageApi: (data) => dispatch(uploadImageApi(data)),
        GetInsuranceServiceWithIdApi: (id) => dispatch(GetInsuranceServiceWithIdApi(id)),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isAddingInsuranceGatePass: state.InsuranceServiceReducer.isAddingInsuranceGatePass,
    insuranceServiceDataList: state.InsuranceServiceReducer.insuranceServiceDataList,
    isFetchingInsuranceService: state.InsuranceServiceReducer.isFetchingInsuranceService,
    UploadImageURL: state.UploadImageReducer.UploadImageURL,
    insuranceServiceDataListWithId: state.InsuranceServiceReducer.insuranceServiceDataListWithId,
});
export default connect(mapStateToProps, mapDispatchToProps)(AddGatePass);